import { DataCache, IDataCommand, injectDataCache } from '@aesop-fables/scrinium';
import { LearningCompartments, learningStorageKey } from '..';
import { inject } from '@aesop-fables/containr';
import { ApiKeys } from '../../../api/apis/ApiKeys';
import { CourseData, LessonData, UnitData } from '../../../models/CourseData';
import { LessonApi } from '../../../api/apis/LessonApi';
import { findLessonSource, updateCourses } from './utils';

export class PublishLesson implements IDataCommand<LessonData, LessonData> {
  constructor(
    @injectDataCache(learningStorageKey) private readonly cache: DataCache<LearningCompartments>,
    @inject(ApiKeys.Lesson) private readonly api: LessonApi,
  ) {}

  async execute(lesson: LessonData): Promise<LessonData> {
    let response: LessonData | undefined;

    // need to update status for all linked versions.
    await this.cache.modify<CourseData[]>('courses', async courses => {
      if (lesson.unitId && lesson.lessonId) {
        const contents = lesson.contents;
        const quiz = lesson.quiz;
        const { data: updatedLesson } = await this.api.publishLesson(lesson);
        updatedLesson.contents = contents;
        updatedLesson.quiz = quiz;
        response = updatedLesson;

        const { courseIndex, unitIndex } = findLessonSource(lesson, courses);
        if (courseIndex !== -1 && typeof unitIndex !== 'undefined' && unitIndex !== -1) {
          const course = courses[courseIndex];
          const units = course.units as UnitData[];
          const unit = units[unitIndex];
          const lessons = unit?.lessons?.map(x => {
            if (x.lessonId === updatedLesson.lessonId) {
              return updatedLesson;
            }
            if (
              x.originalLessonId === updatedLesson.originalLessonId &&
              x.lessonId !== updatedLesson.lessonId &&
              x.active
            ) {
              return { ...x, active: false };
            }

            return x;
          });

          unit.lessons = lessons;

          const newCourses = updateCourses(unit, courses);

          return newCourses;
        }
      }

      return courses;
    });

    return response as LessonData;
  }
}
